angular.module('cimerFrontEndApp').service('TextEditorService', ['$http', 'ApiUrl', function ($http, ApiUrl) {
    'use strict';

    var _apiUrl = ApiUrl.url('/Survey/');

    this.GetTextEditorConfig = function () {
        return {
            inline: true,
            plugins: 'link',
            width: 868,
            height: 150,
            toolbar: 'undo redo | bold italic underline | link | cut copy paste',
            menubar: false,
            valid_elements: 'p,strong/b,em,span[style],a[href|target]',  // do not put spaces between the elements or it'll break
            skin_url: 'Content/Scripts/tinymce-skins/lightgray'
        };
    };

    this.ConvertToPlainText = function (html) {
        var data = {
            HtmlText: html
        };
        return $http.post(_apiUrl + 'GetPlainTextValue', data)
            .then(function (response) {
                if (!response) {
                    return null;
                }
                return response.data;
            });
    };

    // Front-end call. A bit less robust than the backend call, but useful to reduce the number of server calls when working with a lot of fields
    this.ConvertToPlainTextSync = function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        return doc.documentElement.textContent;
    };

    this.GetPlainTextLength = function (html) {
        if (!html) {
            return 0;
        }
        var plainText = this.ConvertToPlainTextSync(html);
        return plainText.length;
    };

}]);